import callAPI from 'api'
import {
  GetLeadCampaignResponse,
  GetLeadCampaignPayload,
  GetLeadCampaignInfoResponse,
  GetLeadCampaignInfoPayload,
  CreateLeadCampaignPayload,
  CreateLeadCampaignResponse,
  UpdateLeadCampaignPayload,
  UpdateLeadCampaignResponse,
  SetLeadCampaignPayload,
} from './types/lead-campaign'

export const getLeadCampaign = async (payload: GetLeadCampaignPayload) =>
  await callAPI<GetLeadCampaignResponse, GetLeadCampaignPayload>('crm_get_lead_campaign_settings', [payload], {
    requireAuthorization: true,
  })

export const createLeadCampaign = async (payload: CreateLeadCampaignPayload) =>
  await callAPI<CreateLeadCampaignResponse, CreateLeadCampaignPayload>('crm_create_lead_campaign', [payload], {
    requireAuthorization: true,
    reloadOnReauth: false,
  })

export const updateLeadCampaign = async (payload: UpdateLeadCampaignPayload) =>
  await callAPI<UpdateLeadCampaignResponse, UpdateLeadCampaignPayload>('crm_update_lead_campaign', [payload], {
    requireAuthorization: true,
    reloadOnReauth: false,
  })

export const getLeadCampaignInfo = async (payload: string) =>
  await callAPI<GetLeadCampaignInfoResponse, GetLeadCampaignInfoPayload>(
    'crm_get_lead_campaign',
    [{ lead_campaign_id: payload }],
    {
      requireAuthorization: true,
    },
  )

export const setLeadCampaignStatus = async (payload: SetLeadCampaignPayload) =>
  await callAPI<{ success: boolean }, SetLeadCampaignPayload>('crm_set_lead_campaign_status', [payload], {
    requireAuthorization: true,
  })

export const deleteLeadCampaign = async (payload: string) =>
  await callAPI<{ success: boolean }, { lead_campaign_id: string }>(
    'crm_delete_lead_campaign',
    [{ lead_campaign_id: payload }],
    {
      requireAuthorization: true,
      reloadOnReauth: false,
    },
  )
